export default {
  SERVER_ENDPOINT: process.env.REACT_APP_SERVER_ENDPOINT,
  PLATFORM_ENDPOINT: process.env.REACT_APP_PLATFORM_ENDPOINT,
  WIDGET_ENDPOINT: process.env.REACT_APP_WIDGET_ENDPOINT,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  GTM_ID: process.env.REACT_APP_GTM_ID,
  SEARCHALITY_US_VERSION: process.env.REACT_APP_SEARCHALITY_US_VERSION,
};
